// Typelizer digest 1fc5aa1e9124a8223f2fea1b997c9ec6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoices/:invoice_id/attachments */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/attachments', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/invoices/:invoice_id/attachments/:id */
  destroy: (
    params: { invoiceId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/attachments/:id', params, options),
    method: 'delete',
  }),
}
